import { createFileRoute, redirect } from '@tanstack/react-router';
import { OnboardingFlow } from '../components/OnboardingFlow';

// Feature flag for onboarding flow
const isOnboardingEnabled = import.meta.env.VITE_FEATURE_ONBOARDING_ENABLED === 'true';

export const Route = createFileRoute('/onboarding')({
  beforeLoad: () => {
    // Redirect to home if onboarding feature is disabled
    if (!isOnboardingEnabled) {
      throw redirect({ to: '/' });
    }
  },
  component: OnboardingPage,
});

function OnboardingPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <OnboardingFlow />
    </div>
  );
}
